import { detectBrowserFamily, isMobileBrowser, type BrowserNavigator } from './browser-family'

export type { BrowserFamily, BrowserNavigator } from './browser-family'
export { detectBrowserFamily, isMobileBrowser }

/** Internal settings URLs must be pasted into the address bar by the user. */
export function getGraphicsSettings(browser: BrowserNavigator = navigator) {
  if (isMobileBrowser(browser)) return null
  const family = detectBrowserFamily(browser)
  if (family === 'edge') {
    return { name: 'Microsoft Edge', url: 'edge://settings/system/manageSystem', guide: 'system' }
  }
  if (family === 'opera') {
    return { name: 'Opera', url: 'opera://settings/system', guide: 'system' }
  }
  if (family === 'vivaldi') {
    return { name: 'Vivaldi', url: 'vivaldi://settings/webpages/', guide: 'webpages' }
  }
  if (family === 'brave') {
    return { name: 'Brave', url: 'brave://settings/system', guide: 'system' }
  }
  if (family === 'firefox') {
    return { name: 'Firefox', url: 'about:preferences#general', guide: 'firefox' }
  }
  if (family === 'chrome') {
    return { name: 'Chrome', url: 'chrome://settings/system', guide: 'system' }
  }
  return null
}

export function getBrowserUpdateSettings(browser: BrowserNavigator = navigator) {
  const settings = getGraphicsSettings(browser)
  if (settings?.name === 'Microsoft Edge') return { name: settings.name, url: 'edge://settings/help' }
  if (settings?.name === 'Chrome') return { name: settings.name, url: 'chrome://settings/help' }
  return null
}

/** Edge throttles itself when it detects a PC game; this setting is Edge-only. */
export function getGameAccelerationSettings(browser: BrowserNavigator = navigator) {
  const settings = getGraphicsSettings(browser)
  if (settings?.name !== 'Microsoft Edge') return null
  return { name: settings.name, url: 'edge://settings/system/managePerformance' }
}
